import type {
  BrandAggregationQuery,
  BrandAggregationQueryVariables,
} from '@/lib/goliath/goliath.types';

export default async (
  params: BrandAggregationQueryVariables = {},
  progress = true
): Promise<NonNullable<NonNullable<BrandAggregationQuery['offers']>['aggregations']>['brands']> => {
  const data = await globalThis.$goliathApi<
    BrandAggregationQueryVariables,
    BrandAggregationQuery,
    'offers'
  >('brand-aggregation', params, 'offers', progress);

  return data?.aggregations?.brands || [];
};
